/** Discord server boost storefront SKUs (kept separate to avoid products ↔ productFamilies cycles). */
export const SERVER_BOOST_PRODUCT_ID = 134
/** 3-month server boost listing. */
export const SERVER_BOOST_3M_PRODUCT_ID = 135
export const SERVER_BOOST_PRODUCT_IDS = [SERVER_BOOST_PRODUCT_ID, SERVER_BOOST_3M_PRODUCT_ID] as const
